<template>
  <div class="text-center" v-if="stakersAddress === null">
    <h5>Please log into Metamask first, then refresh this website...</h5>
  </div>

  <div
    class="col-xxl-10 col-xl-10 col-lg-10 col-md-10 col-sm-12 mx-auto"
    v-if="stakersAddress !== null && stakersAllowance4LevelingE18 <= 0"
  >
    <div class="card">
      <div class="card-body">
        <span
          >Before you can upgrade your NFTs, you need to approve the SVC token
          once.</span
        >

        &nbsp;

        <button
          class="btn btn-std"
          type="button"
          id="approveRewardToken"
          @click="approveRewardToken"
        >
          approve SVC
        </button>
      </div>
    </div>
  </div>

  <br />

  <div class="card" v-if="stakersAddress !== null">
    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="card-body">
        <h4 class="animate-characters">
          {{ selectedNfts.length }} of {{ stakersNfts.length }} NFTs selected
        </h4>
        <br />

        <button
          v-if="expandFilter === false"
          class="btn btn-std"
          type="button"
          @click.stop="expandFilter = true"
        >
          Filter
          <i class="ri-arrow-down-s-line"></i>
        </button>
        <button
          v-else
          class="btn btn-outline-std"
          type="button"
          @click="collapseMenus"
        >
          Filter
          <i class="ri-arrow-up-s-line"></i>
        </button>

        &nbsp;

        <button
          @click="selectVisible"
          class="btn btn-success"
          style="font-size: 14px"
        >
          Select all
        </button>

        &nbsp;

        <button
          @click="clearSelection"
          class="btn btn-danger"
          style="font-size: 14px"
        >
          Clear selection
        </button>
        &nbsp;
        <button
          @click="upgradeSelectedNfts()"
          class="btn btn-success"
          :disabled="
            selectedNfts.length <= 0 ||
            stakersAllowance4LevelingE18 <= 0 ||
            stakersBalanceE18 <= 0 ||
            stakingPaused
          "
          style="font-size: 14px"
        >
          Upgrade {{ Math.min(selectedNfts.length, maxNftsPerTx) }} for
          {{ cost2BulkUpgradeE18 }}
          SVC
        </button>
        &nbsp;
        <button
          @click="stakeSelected"
          class="btn btn-success"
          :disabled="selectedNfts.length <= 0 || stakingPaused"
          style="font-size: 14px"
        >
          Stake {{ Math.min(selectedNfts.length, maxNftsPerTx) }}
        </button>
        &nbsp;
        <button
          @click="unstakeSelected"
          class="btn btn-danger"
          :disabled="selectedNfts.length <= 0 || stakingPaused"
          style="font-size: 14px"
        >
          Unstake {{ Math.min(selectedNfts.length, maxNftsPerTx) }}
        </button>
        <p v-if="selectedNfts.length > maxLevel">
          Note: {{ maxLevel }} NFTs max staking and unstaking in 1 transaction
        </p>

        <ul v-if="expandFilter">
          <hr class="my-0" />
          <a
            class="dropdown-item"
            href="#"
            @click="filterNfts('all')"
            v-bind:class="filter === null ? 'current' : ''"
            >All ({{ stakersNfts.length }})</a
          >

          <a
            class="dropdown-item"
            href="#"
            @click="filterNfts('staked')"
            v-bind:class="filter === 'staked' ? 'current' : ''"
            >Staked ({{ stakedCount }})</a
          >

          <a
            class="dropdown-item"
            href="#"
            @click="filterNfts('unstaked')"
            v-bind:class="filter === 'unstaked' ? 'current' : ''"
            >Unstaked ({{ unstakedCount }})</a
          >
          <hr class="my-0" />
        </ul>
      </div>
    </div>

    <br />

    <template v-if="loadingNfts === false && filteredNfts.length <= 0">
      <h1 class="text-center">No NFTs to display</h1>
    </template>

    <div class="row" v-else>
      <div
        class="col-xxl-2 col-xl-3 col-lg-4 col-md-4 col-sm-6"
        v-for="tokenId in filteredNfts"
        :key="tokenId"
      >
        <div class="card items">
          <div
            :class="
              selectedNfts.includes(tokenId)
                ? 'card-selected card-body'
                : 'card-body'
            "
            @click="selectNft(tokenId)"
          >
            <div class="row">
              <label>
                <h5>#{{ tokenId }}</h5>
              </label>
            </div>
            <div class="items-img position-relative">
              <img
                :src="pictureLink + tokenId + '.png'"
                class="img-fluid rounded mb-3"
                alt=""
              />
            </div>

            <!-- <table class="mx-auto my-4" style="width: 100%">
              <tr>
                <th style="width: 36%">
                  <h5>#{{ tokenId }}</h5>
                </th>
                <th style="width: 32%"></th>
                <th style="width: 32%"></th>
              </tr>
              <tr>
                <td>Current:</td>
                <td>
                  <span title="current level">
                    🏆{{ nftInfo[tokenId].level }}
                  </span>
                </td>
                <td>
                  <span title="current staking power">
                    🔥{{ powerForLevel[nftInfo[tokenId].level] }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>After upgrade:</td>
                <td>
                  🏆
                  <input
                    type="number"
                    title="level after upgrade"
                    v-if="nftInfo[tokenId].nftLevelAfterUpgrade <= maxLevel"
                    @change="updateLevelsToUpgrade(tokenId)"
                    :min="nftInfo[tokenId].level + 1"
                    :max="maxLevel"
                    style="width: 3em"
                    v-model="nftInfo[tokenId].nftLevelAfterUpgrade"
                  />
                </td>
                <td>
                  <span title="power after upgrade">
                    🔥{{ powerForLevel[nftInfo[tokenId].nftLevelAfterUpgrade] }}
                  </span>
                </td>
              </tr>
            </table> -->

            <h6 class="mb-1" @click.stop>
              Current: &nbsp;
              <span title="current level">
                🏆{{ nftInfo[tokenId].level }}
              </span>
              &nbsp;
              <span title="current staking power">
                🔥{{ powerForLevel[nftInfo[tokenId].level] }}
              </span>
            </h6>

            <template v-if="nftInfo[tokenId].level < maxLevel">
              <table class="mx-auto mb-1" style="width: 100%" @click.stop>
                <tr>
                  <td style="width: 13%">
                    <button
                      class="btn btn-sm"
                      :disabled="
                        nftInfo[tokenId].nftLevelAfterUpgrade <=
                        nftInfo[tokenId].level + 1
                      "
                      @click="
                        nftInfo[tokenId].nftLevelAfterUpgrade -= 1;
                        updateLevelsToUpgrade(tokenId);
                      "
                    >
                      -
                    </button>
                  </td>
                  <td style="width: 74%">
                    <input
                      type="range"
                      title="Choose desired level after upgrade"
                      class="form-control-range"
                      :min="nftInfo[tokenId].level + 1"
                      :max="maxLevel"
                      id="levelsToUpgradeSlider"
                      v-model="nftInfo[tokenId].nftLevelAfterUpgrade"
                      @change="updateLevelsToUpgrade(tokenId)"
                      @click.stop
                    />
                  </td>
                  <td style="width: 13%">
                    <button
                      class="btn btn-sm"
                      :disabled="
                        nftInfo[tokenId].nftLevelAfterUpgrade >= maxLevel
                      "
                      @click="
                        nftInfo[tokenId].nftLevelAfterUpgrade += 1;
                        updateLevelsToUpgrade(tokenId);
                      "
                    >
                      +
                    </button>
                  </td>
                </tr>
              </table>
            </template>

            <h6
              v-if="nftInfo[tokenId].level < maxLevel"
              class="text-muted mx-auto"
              @click.stop
            >
              After upgrade: 🏆
              <input
                type="number"
                title="level after upgrade"
                v-if="nftInfo[tokenId].nftLevelAfterUpgrade <= maxLevel"
                @change="updateLevelsToUpgrade(tokenId)"
                :min="nftInfo[tokenId].level + 1"
                :max="maxLevel"
                style="width: 3em"
                v-model="nftInfo[tokenId].nftLevelAfterUpgrade"
              />
              <span title="power after upgrade">
                🔥{{ powerForLevel[nftInfo[tokenId].nftLevelAfterUpgrade] }}
              </span>
            </h6>

            <div class="d-flex justify-content-center mt-3">
              <button
                v-if="nftInfo[tokenId].staked"
                @click.stop="unstake(tokenId)"
                class="btn btn-danger"
                :disabled="stakingPaused"
                style="font-size: 14px"
              >
                Unstake
              </button>
              <button
                v-else
                @click.stop="stake(tokenId)"
                class="btn btn-std"
                :disabled="stakingPaused"
                style="font-size: 14px"
              >
                Stake
              </button>

              &nbsp;

              <button
                v-if="stakersAllowance4LevelingE18 <= 0"
                class="btn btn-std"
                type="button"
                id="approveRewardToken"
                @click.stop="approveRewardToken"
                style="font-size: 14px"
              >
                approve SVC
              </button>

              <button
                v-else-if="nftInfo[tokenId].nftLevelAfterUpgrade <= maxLevel"
                @click.stop="
                  upgradeSpecificNft(tokenId, nftInfo[tokenId].levelsToUpgrade)
                "
                class="btn btn-std"
                :disabled="
                  stakersBalanceE18 <= 0 ||
                  nftInfo[tokenId].level >= maxLevel ||
                  stakingPaused
                "
                style="font-size: 14px"
              >
                Upgrade
                {{ nftInfo[tokenId].levelsToUpgrade }} level<template
                  v-if="nftInfo[tokenId].levelsToUpgrade != 1"
                  >s</template
                >
                for
                {{ nftInfo[tokenId].levelsToUpgrade * costPerLvlE18 }}
                SVC
              </button>

              <button
                v-else
                @click.stop="setFeedback('Congratulations!', 3000)"
                class="btn btn-std"
                style="font-size: 14px"
              >
                Max. level reached!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="popup" v-if="loadingNfts === true && stakersAddress !== null">
    <div class="popupX" @click="loadingNfts = false">x</div>
    <h5 class="text-monospace animate-popup">Loading NFTs...</h5>
  </div>

  <div class="popup" v-if="txInProgress || feedbackMessage != ''">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 v-if="feedbackMessage != ''" class="text-monospace animate-popup">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h5 v-if="txInProgress" class="text-monospace animate-popup">
      Waiting for current transaction to finish...
    </h5>
  </div>
</template>

<script>
import { ethers } from "ethers";
import Reaperville from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";

function removeItemOnce(arr, value) {
  let index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1); // 2nd parameter: Amount of elements to remove
  } else {
    console.log("Unstaking an NFT that has not been staked before!");
  }
  return arr;
}

// function matchesAllFilters(nft, filters) {
//   for (const [category, traits] of Object.entries(filters)) {
//     if (0 === traits.length) {
//       // console.log("No filter on " + category + " specified");
//       continue;
//     } else if (-1 === traits.indexOf(nft["traits"][category])) {
//       // console.log("Specified traits for " + category + " not in nft " + nft.id +". Trait is " + nft["traits"][category]);
//       return false;
//     }
//   }
//   // console.log(nft.id + " matches all filters");
//   return true;
// }

export default {
  name: "App",
  props: ["nftCA", "projectname", "pictureLink"],
  emits: ["refreshEvent"],

  data() {
    return {
      expandFilter: false,

      rpc: null,

      maxLevel: 100,
      costPerLvlE18: 100,
      cost2BulkUpgradeE18: 0,

      powerForLevel: [
        1000, 1050, 1104, 1162, 1224, 1291, 1363, 1440, 1523, 1613, 1710, 1815,
        1928, 2051, 2184, 2329, 2486, 2657, 2844, 3048, 3271, 3515, 3782, 4075,
        4397, 4730, 5074, 5428, 5792, 6165, 6546, 6934, 7329, 7730, 8136, 8546,
        8959, 9375, 9793, 10212, 10632, 11051, 11469, 11886, 12301, 12713,
        13122, 13527, 13928, 14324, 14715, 15101, 15481, 15855, 16223, 16584,
        16939, 17287, 17628, 17962, 18288, 18607, 18918, 19222, 19519, 19808,
        20090, 20364, 20631, 20891, 21143, 21391, 21634, 21873, 22107, 22336,
        22561, 22781, 22997, 23210, 23421, 23630, 23836, 24040, 24242, 24441,
        24638, 24833, 25025, 25215, 25402, 25587, 25770, 25950, 26128, 26304,
        26477, 26648, 26817, 26983, 27147,
      ],

      maxNftsPerTx: 50,

      showLevelingExplanation: false,

      stakersAddress: null,

      currentCollection: null,

      stakersBalanceE18: 0,
      stakersAllowance4LevelingE18: 0,

      contracts: {},

      provider: null,
      signer: null,

      loadingNfts: true,

      stakersNfts: [],
      filteredNfts: [],
      filter: "all",
      selectedNfts: [],
      nftInfo: {},

      stakedCount: 0,
      unstakedCount: 0,

      nftLevel: {},

      feedbackMessage: "",
      txInProgress: false,
      lastTimeout: 0,

      stakingPaused: true,
    };
  },

  methods: {
    // updateFilters: function () {
    //   that.filters = {}
    //   filters.Background = getSelectValues(document.getElementById("Background"));
    //   filters.Fur = getSelectValues(document.getElementById("Fur"));
    //   filters.Clothes = getSelectValues(document.getElementById("Clothes"));
    //   filters.Eyes = getSelectValues(document.getElementById("Eyes"));
    //   filters.Mouth = getSelectValues(document.getElementById("Mouth"));
    //   filters.Earring = getSelectValues(document.getElementById("Earring"));
    //   filters.Hat = getSelectValues(document.getElementById("Hat"));
    //   filters.Profile = getSelectValues(document.getElementById("Profile"));
    //   filters.Special = getSelectValues(document.getElementById("Special"));
    //   filters.trait_count = getSelectValues(document.getElementById("trait_count"));

    //   for (let nft of that.sts) {
    //     if (false == matchesAllFilters(nft, filters)) continue;
    //   }
    // },
    collapseMenus: function () {
      this.expandFilter = false;
    },

    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    selectNft: function (_tokenId) {
      let that = this;
      if (that.selectedNfts.indexOf(_tokenId) < 0) {
        that.selectedNfts.push(_tokenId);
      } else {
        removeItemOnce(that.selectedNfts, _tokenId);
      }
      that.updateCostForBulkUpgrade();
    },

    updateLevelsToUpgrade: function (_tokenId) {
      let that = this;
      that.nftInfo[_tokenId].nftLevelAfterUpgrade = Math.round(
        that.nftInfo[_tokenId].nftLevelAfterUpgrade
      );
      if (that.selectedNfts.indexOf(_tokenId) < 0) {
        that.selectedNfts.push(_tokenId);
      }
      if (that.nftInfo[_tokenId].nftLevelAfterUpgrade > that.maxLevel) {
        that.nftInfo[_tokenId].nftLevelAfterUpgrade = that.maxLevel;
      } else if (
        that.nftInfo[_tokenId].nftLevelAfterUpgrade <
        that.nftInfo[_tokenId].level + 1
      ) {
        that.nftInfo[_tokenId].nftLevelAfterUpgrade =
          that.nftInfo[_tokenId].level + 1;
      }
      that.nftInfo[_tokenId].levelsToUpgrade =
        that.nftInfo[_tokenId].nftLevelAfterUpgrade -
        that.nftInfo[_tokenId].level;

      that.updateCostForBulkUpgrade();
    },

    getInitialLevel: function (_tokenId) {
      // set initial level
      if (_tokenId < 10) {
        return 10;
      } else if (_tokenId == 2500) {
        return 0;
      } else {
        return 9 - Math.floor(_tokenId / 250);
      }
    },

    getPower: function (_tokenId) {
      return this.powerForLevel[this.nftInfo[_tokenId].level];
    },

    approveRewardToken: async function () {
      let that = this;

      that.setFeedback("Approving SVC token", 0);
      that.txInProgress = true;

      try {
        let tx = await that.contracts["svc"].approve(
          window.ca["reaper"],
          ethers.constants.MaxUint256,
          {
            gasLimit: 65000, // 60k is probably fine, too
          }
        );
        // gasPrice: 1046740000,
        await tx.wait();
        that.contracts["svc"]
          .allowance(that.stakersAddress, window.ca["reaper"])
          .then((allowance) => {
            that.stakersAllowance4LevelingE18 = allowance / 10 ** 18;
          });
        that.feedbackMessage = "";
        that.txInProgress = false;
      } catch {
        that.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    stake: async function (tokenId) {
      this.txInProgress = true;
      this.setFeedback("Staking NFT", 0);

      try {
        let tx = await this.contracts["staking"].stake([tokenId], {
          gasLimit: 280000,
        });
        // let tx = await this.contracts['staking'].stake([tokenId]);
        await tx.wait();

        this.txInProgress = false;
        this.feedbackMessage = "";

        this.$emit("refreshEvent");
        this.load();
      } catch {
        this.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    unstake: async function (tokenId) {
      this.txInProgress = true;
      this.setFeedback("Unstaking NFT", 0);
      try {
        let tx = await this.contracts["staking"].unstake([tokenId], {
          gasLimit: 290000,
        });
        await tx.wait();
        this.txInProgress = false;
        this.feedbackMessage = "";
        this.$emit("refreshEvent");
        this.load();
      } catch {
        this.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    selectVisible: function () {
      this.feedbackMessage = "";
      this.selectedNfts = [];
      for (let tokenId of this.filteredNfts) {
        if (this.selectedNfts.indexOf(tokenId) < 0) {
          this.selectedNfts.push(tokenId);
        }
      }

      this.updateCostForBulkUpgrade();
    },

    clearSelection: function () {
      this.feedbackMessage = "";
      this.selectedNfts = [];
      this.updateCostForBulkUpgrade();
    },

    stakeSelected: async function () {
      this.txInProgress = true;
      this.setFeedback("Staking NFTs", 0);

      let IDs = [];

      for (let tokenId of this.selectedNfts) {
        if (
          this.nftInfo[tokenId].staked === false &&
          IDs.length < this.maxNftsPerTx
        ) {
          // console.log(this.selectedNfts[i], this.stakersNfts[findIdx]);
          IDs.push(tokenId);
        }
      }

      this.selectedNfts = IDs.slice();

      if (IDs.length === 0) {
        this.setFeedback("No selected NFT matches all criteria.", 2000);
        this.txInProgress = false;
        return false;
      } else {
        this.setFeedback("Staking selected NFTs.", 0);
      }

      try {
        let tx = await this.contracts["staking"].stake(IDs, {
          gasLimit: Math.min(100000 + 180000 * IDs.length, 9999999),
        });
        // gasPrice: 1046740000,
        await tx.wait();

        this.txInProgress = false;
        this.feedbackMessage = "";

        this.$emit("refreshEvent");
        this.load();
      } catch {
        this.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    unstakeSelected: async function () {
      this.txInProgress = true;
      this.setFeedback("Unstaking NFTs", 0);

      let IDs = [];

      for (let tokenId of this.selectedNfts) {
        if (
          this.nftInfo[tokenId].staked === true &&
          IDs.length < this.maxNftsPerTx
        ) {
          // console.log(this.selectedNfts[i], this.filteredNfts[findIdx]);
          IDs.push(tokenId);
        }
      }

      this.selectedNfts = IDs.slice();

      if (IDs.length === 0) {
        this.setFeedback("No selected NFT matches all criteria.", 2000);
        return false;
      } else {
        this.setFeedback("Unstaking selected NFTs.", 0);
      }

      try {
        let tx = await this.contracts["staking"].unstake(IDs, {
          gasLimit: Math.min(125000 + 200000 * IDs.length, 9999999),
        });
        // gasPrice: 1046740000,
        await tx.wait();

        this.txInProgress = false;
        this.feedbackMessage = "";

        this.$emit("refreshEvent");
        this.load();
      } catch {
        this.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    updateCostForBulkUpgrade: function () {
      let nftsFound = 0;
      let _cost2BulkUpgradeE18 = 0;

      for (let idx = 0; idx < this.selectedNfts.length; idx++) {
        let tokenId = this.selectedNfts[idx];
        let costE18 =
          this.nftInfo[tokenId].levelsToUpgrade * this.costPerLvlE18;
        if (nftsFound < this.maxNftsPerTx) {
          _cost2BulkUpgradeE18 += costE18;
          nftsFound++;
        }
      }
      this.cost2BulkUpgradeE18 = _cost2BulkUpgradeE18;
    },

    upgradeSpecificNft: async function (_tokenId, _levelsToUpgrade) {
      let that = this;

      this.feedbackMessage = "";

      if (_levelsToUpgrade === 0) {
        this.setFeedback("Can't upgrade 0 levels", 2000);
        return false;
      }

      let _cost4UpgradeE18 = _levelsToUpgrade * that.costPerLvlE18;

      // checking SVC token
      if (_cost4UpgradeE18 > that.stakersAllowance4LevelingE18) {
        that.setFeedback(
          "Please increase your SVC token allowance first",
          2000
        );
        return false;
      } else if (_cost4UpgradeE18 > that.stakersBalanceE18) {
        that.setFeedback("SVC balance is too low", 2000);
        return false;
      }

      let level = that.nftInfo[_tokenId].level;
      if (level >= that.maxLevel) {
        that.setFeedback(
          "Cannot upgrade " + _tokenId + ", because it's already at max. level",
          2000
        );
        return false;
      }

      // check owner
      let _nftOwner = await that.contracts["nft"].ownerOf(_tokenId);
      if (_nftOwner !== that.stakersAddress) {
        if (_nftOwner !== window.ca["reaper"]) {
          that.setFeedback(
            "Cannot upgrade " + _tokenId + ", because it's not in your wallet",
            2000
          );
          return false;
        }
      }

      that.setFeedback(
        "Upgrading 1 NFT by " +
          _levelsToUpgrade +
          " levels with " +
          _cost4UpgradeE18 +
          " SVC",
        0
      );
      console.log(that.feedbackMessage);

      console.log("Power old= " + that.getPower(_tokenId));
      console.log("Level old= " + level);
      console.log("Balance old= " + that.stakersBalanceE18);
      let balanceNew = that.stakersBalanceE18 - _cost4UpgradeE18;
      console.log("Balance new= " + balanceNew);

      that.txInProgress = true;

      try {
        let tx = await that.contracts["staking"].upgradeLevel(
          [_tokenId],
          [_levelsToUpgrade],
          {
            gasLimit: 240000,
          }
        );
        // gasPrice: 1046740000,
        await tx.wait();

        await that.contracts["staking"].getLevelView(_tokenId).then((level) => {
          that.nftInfo[_tokenId] = {
            level: level,
            nftLevelAfterUpgrade: level + 1,
            levelsToUpgrade: 1,
          };
        });

        that.sortNfts();

        that.txInProgress = false;
        that.feedbackMessage = "";

        that.$emit("refreshEvent");
      } catch {
        this.txInProgress = false;
        this.setFeedback("The transaction failed :(", 2000);
      }
    },

    upgradeSelectedNfts: async function () {
      this.feedbackMessage = "";

      let that = this;

      // checking SVC token
      if (that.cost2BulkUpgradeE18 > that.stakersAllowance4LevelingE18) {
        this.setFeedback(
          "Please increase your SVC token allowance first",
          2000
        );
        return false;
      } else if (that.cost2BulkUpgradeE18 > that.stakersBalanceE18) {
        this.setFeedback("SVC token balance is too low", 2000);
        return false;
      }

      if (that.selectedNfts.length < 1) {
        this.setFeedback("No NFTs selected", 2000);
        return false;
      } else if (that.selectedNfts.length == 1) {
        let tokenId = that.selectedNfts[0];
        let level = that.nftInfo[tokenId].level;
        if (level >= that.maxLevel) {
          that.setFeedback(
            "Cannot upgrade " +
              tokenId +
              ", because it's already at max. level",
            2000
          );
          console.log(that.feedbackMessage);
          return false;
        }

        // check owner
        let _nftOwner = await this.contracts["nft"].ownerOf(tokenId);
        if (_nftOwner !== that.stakersAddress) {
          if (_nftOwner !== window.ca["reaper"]) {
            that.setFeedback("You don't own " + tokenId, 2000);
            return false;
          }
        }

        that.setFeedback(
          "Upgrading 1 NFT by " +
            that.nftInfo[tokenId].levelsToUpgrade +
            " levels",
          0
        );
        console.log(that.feedbackMessage);

        console.log("Level old= " + level);
        console.log("Balance old= " + that.stakersBalanceE18);
        let balanceNew = that.stakersBalanceE18 - that.cost2BulkUpgradeE18;
        console.log("Balance new= " + balanceNew);

        this.txInProgress = true;
        try {
          let tx = await that.contracts["staking"].upgradeLevel(
            [tokenId],
            [that.nftInfo[tokenId].levelsToUpgrade],
            {
              gasLimit: 240000,
            }
          );
          // gasPrice: 1046740000,
          await tx.wait();

          await that.contracts["staking"]
            .getLevelView(tokenId)
            .then((level) => {
              that.nftInfo[tokenId] = {
                level: level,
                nftLevelAfterUpgrade: level + 1,
                levelsToUpgrade: 1,
              };
            });

          that.sortNfts();
          that.$emit("refreshEvent");
        } catch {
          this.txInProgress = false;
          this.setFeedback("The transaction failed :(", 2000);
        }
      } else if (that.selectedNfts.length > 1) {
        // go through selected NFTs and pick first maxNftsPerTx which qualify for an upgrade
        let nftsToUpgradeArray = [];
        let levelsToUpgradeArray = [];
        that.setFeedback("Double checking selected NFTs", 2000);
        for (
          let i = 0;
          i < that.selectedNfts.length &&
          nftsToUpgradeArray.length < that.maxNftsPerTx;
          i++
        ) {
          let tokenId = that.selectedNfts[i];
          // check cost
          if (that.nftInfo[tokenId].levelsToUpgrade === 0) {
            that.feedbackMessage +=
              " — Skipping " + tokenId + " (0 SVC upgrade)";
            continue;
          }

          // check level
          if (that.nftInfo[tokenId].level >= that.maxLevel) {
            that.feedbackMessage +=
              " — Skipping " + tokenId + " (already at max level)";
            continue;
          }

          // // check owner
          // let _nftOwner = await this.contracts['nft'].ownerOf(tokenId);
          // if (_nftOwner !== that.stakersAddress) {
          //   if (_nftOwner !== window.ca['reaper']) {
          //     that.feedbackMessage +=
          //       " — Skipping " + tokenId + " (not in your wallet)";
          //     console.log(that.feedbackMessage);
          //   }
          // }

          nftsToUpgradeArray.push(that.selectedNfts[i]);
          levelsToUpgradeArray.push(that.nftInfo[tokenId].levelsToUpgrade);
          console.log("Adding " + tokenId);
          console.log(nftsToUpgradeArray);
        }

        that.feedbackMessage +=
          " — " + nftsToUpgradeArray.length + " NFTs passed all checks";
        console.log(nftsToUpgradeArray);
        console.log(levelsToUpgradeArray);
        console.log("Bulk Upgrade Cost= " + that.cost2BulkUpgradeE18);

        console.log("Balance old=" + that.stakersBalanceE18);
        let powBalanceAfterUpgrade =
          that.stakersBalanceE18 - that.cost2BulkUpgradeE18;
        console.log("Balance after bulk upgrade: ", powBalanceAfterUpgrade);

        if (nftsToUpgradeArray.length <= 0) {
          return false;
        }

        that.feedbackMessage +=
          " — Upgrading NFTs [" +
          nftsToUpgradeArray +
          "] by [" +
          levelsToUpgradeArray +
          "] levels";

        this.txInProgress = true;
        try {
          let tx = await this.contracts["staking"].upgradeLevel(
            nftsToUpgradeArray,
            levelsToUpgradeArray,
            {
              gasLimit: Math.min(
                70000 + 160000 * nftsToUpgradeArray.length,
                9999999
              ),
            }
          );
          // gasPrice: 1046740000,
          await tx.wait();

          this.$emit("refreshEvent");
          this.load();
        } catch {
          this.txInProgress = false;
          this.setFeedback("The transaction failed :(", 2000);
        }
      }
    },

    filterNfts: function (_param) {
      let that = this;

      that.collapseMenus();

      that.filter = _param;

      switch (_param) {
        case "all":
          that.filteredNfts = that.stakersNfts;
          // staked = that.stakersNfts.filter((tokenId) => {
          //   return that.nftInfo[tokenId].staked === true;
          // });
          // unstaked = that.stakersNfts.filter((tokenId) => {
          //   return that.nftInfo[tokenId].staked === false;
          // });
          // that.filteredNfts = staked.concat(unstaked);
          break;
        case "staked":
          that.filteredNfts = that.stakersNfts.filter((tokenId) => {
            return that.nftInfo[tokenId].staked === true;
          });
          break;
        case "unstaked":
          that.filteredNfts = that.stakersNfts.filter((tokenId) => {
            return that.nftInfo[tokenId].staked === false;
          });
          break;
        default:
          that.setFeedback("Filter not implemented", 2000);
      }
    },

    getWalletOfOwner: async function (slice) {
      let that = this;
      //////////////////////////////////////////////////////////////////
      // load wallet of owner (includes staked and unstaked NFTs)     //
      // and levels for NFTs (level = level + 1000 for unstaked NFTs) //
      //////////////////////////////////////////////////////////////////
      const maxNftsToGetIn1Tx = 500;
      return new Promise((resolve, reject) => {
        let tokenLevelsLength = 0;
        let ownerTokenCount = 0;

        console.log("slice=", slice);
        that.contracts["nft"]
          .walletOfOwnerWithLevels(
            that.stakersAddress,
            maxNftsToGetIn1Tx,
            slice
          )
          .then((tokensLevels) => {
            // console.log("tokensLevels=", tokensLevels);

            tokenLevelsLength = tokensLevels.length;
            if (
              2 * Math.floor(tokensLevels.length / 2) + 1 !==
              tokensLevels.length
            ) {
              console.log(
                "Critical error! tokenLevelsLength should always be an odd number! tokenLevelsLength=",
                tokenLevelsLength
              );
            }

            // last element is ownerTokenCount — skip last element in loop
            ownerTokenCount = tokensLevels[tokensLevels.length - 1];

            for (let iCopy = 0; iCopy < tokensLevels.length - 1; iCopy += 2) {
              let tokenId = Number(tokensLevels[iCopy]);
              let level = Number(tokensLevels[iCopy + 1]);
              let staked = false;
              if (level > that.maxLevel) {
                level -= 1000;
                staked = false;
                that.unstakedCount++;
              } else {
                staked = true;
                that.stakedCount++;
              }

              if (level === 0) {
                level = that.getInitialLevel(tokenId);
              }

              that.stakersNfts.push(tokenId);
              that.nftInfo[tokenId] = {
                staked: staked,
                level: level,
                nftLevelAfterUpgrade: level + 1,
                levelsToUpgrade: 1,
              };
            }
          })
          .then(() => {
            if ((slice + 1) * maxNftsToGetIn1Tx < ownerTokenCount) {
              console.log("tokenLevelsLength", tokenLevelsLength);
              that.getWalletOfOwner(slice + 1).then(() => {
                resolve();
              });
            } else {
              resolve();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },

    sortNfts: function () {
      let that = this;

      that.stakersNfts.sort(function (a, b) {
        return (
          that.nftInfo[b].staked - that.nftInfo[a].staked ||
          that.nftInfo[b].level - that.nftInfo[a].level ||
          a - b
        );
      });
    },

    reload: function () {
      // load SVC balance and allowance
      this.contracts["svc"].balanceOf(this.stakersAddress).then((balance) => {
        this.stakersBalanceE18 = balance / 10 ** 18;
      });
      this.contracts["svc"]
        .allowance(this.stakersAddress, window.ca["reaper"])
        .then((allowance) => {
          this.stakersAllowance4LevelingE18 = allowance / 10 ** 18;
        });
    },

    load: async function () {
      let that = this;
      that.loadingNfts = true;
      this.txInProgress = false;
      this.feedbackMessage = "";

      that.selectedNfts = [];

      that.filteredNfts = [];
      that.stakersNfts = [];
      that.stakedCount = 0;
      that.unstakedCount = 0;

      that.stakersAddress = await that.signer.getAddress();

      that.contracts["staking"].isMintPausedStakingPaused().then((result) => {
        console.log(result);
        that.stakingPaused = result[1];
      });

      // load SVC balance and allowance
      that.contracts["svc"].balanceOf(that.stakersAddress).then((balance) => {
        that.stakersBalanceE18 = balance / 10 ** 18;
      });
      that.contracts["svc"]
        .allowance(that.stakersAddress, window.ca["reaper"])
        .then((allowance) => {
          that.stakersAllowance4LevelingE18 = allowance / 10 ** 18;
        });

      that.getWalletOfOwner(0).then(() => {
        that.sortNfts();

        console.log("calling filter");
        that.filterNfts(that.filter);

        that.loadingNfts = false;
      });
    },
  },

  mounted: function () {
    this.rpc = window.ethereum; // doesn't work on Android due to a bug(?)

    this.provider = new ethers.providers.Web3Provider(this.rpc, "any");

    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();

        this.contracts["nft"] = new ethers.Contract(
          this.nftCA.toString(),
          Reaperville.abi,
          this.signer
        );
        this.contracts["staking"] = new ethers.Contract(
          window.ca["reaper"],
          Reaperville.abi,
          this.signer
        );

        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );
      })
      .then(() => {
        this.load();
      });
  },
};
</script>

<style scoped>
th,
td {
  background-color: #511da338;
}
</style>
